var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{directives:[{name:"localize",rawName:"v-localize"}]},[_vm._v(_vm._s(_vm.text ?? "Not available."))])
}
var staticRenderFns = []

export { render, staticRenderFns }